import React from 'react';

export function databaseContactWarning(accessibleDatabaseContacts, displayName) {
  if (accessibleDatabaseContacts.length === 0) return null;

  const databaseName = <strong>{accessibleDatabaseContacts[0].databaseName}</strong>;
  return (
    <p>
      Since <strong>{displayName}</strong> exists in {databaseName}, any information you change will also be changed
      for this Contact in {databaseName}.
    </p>
  );
}
